import CssBaseline from '@material-ui/core/CssBaseline';
import MuiThemeProvider from '@material-ui/styles/ThemeProvider';
import FormFieldsContext from '@react-form-fields/material-ui/components/Context';
import { theme } from 'assets/theme';
import AppRouter, { RouterContext } from 'components/Router';
import Alert from 'components/Shared/Alert';
import Snackbar from 'components/Shared/Snackbar';
import 'fieldConfig';
import fieldConfig from 'fieldConfig';
import React, { createRef } from 'react';
import baseRoutes from 'routes';
import './assets/global.css';
import { useEffect } from 'react';
import { messaging } from 'helpers/firebase';

const App = () => {
  const router = createRef<AppRouter>();

  const getRouter = () => {
    return router.current;
  };

  useEffect(() => {
    messaging &&
      messaging.onMessage((payload) => {
        console.log('Message received Component. ', payload);
      });
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <FormFieldsContext config={fieldConfig}>
        <CssBaseline />
        <Alert.Global />
        <Snackbar.Global />

        <RouterContext.Provider value={getRouter}>
          <AppRouter routes={baseRoutes} ref={router} />
        </RouterContext.Provider>
      </FormFieldsContext>
    </MuiThemeProvider>
  );
};

export default App;
